import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontClickEvent} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {InfoBubblePillVariantsEnum} from '../../../../../libs/shared/ui/src/components/tip/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Component.
 */

export const AiAnswersTeammateHandoffEducationTip: FC<SandboxEducationTipProps> = (props) => {
  const {trackDataEvent} = useDataEventTracking();

  const onEndDemoClick = (event: FrontClickEvent) => {
    trackDataEvent(
      DataEventActionsEnum.CLICK,
      OnboardingDataEventObject.DEMO_AI_ANSWERS_TEAMMATE_HANDOFF,
      {},
    );
    props.onEndClick(event, {shouldAdvanceStep: true});
  };

  return (
    <EducationTip
      anchor={props.anchor}
      position="left"
      isVisible={props.isVisible}
      isStandalone
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={
        <Trans id="infobubble-onboarding-ai-answers-teammate-handoff-title">
          Seamlessly hand off to a teammate
        </Trans>
      }
      stepCounter={generateStepText(4, 4)}
      onPrimaryClick={onEndDemoClick}
      primaryActionLabel={
        <Trans id="infobubble-onboarding-ai-answers-teammate-handoff-primary">End demo</Trans>
      }
      dataObjectName={OnboardingDataEventObject.DEMO_AI_ANSWERS_TEAMMATE_HANDOFF}
    >
      <Trans id="infobubble-onboarding-ai-answers-teammate-handoff-description">
        Chatbots can automatically loop in the right teammate when needed. Since Marisa is handling this one,
        we can finish up.
      </Trans>
    </EducationTip>
  );
};
